// src/components/About.js
import React, { useState,useEffect, useRef } from 'react';
import CustomDropdown from '../../components/common/CustomDropdown';

const AdvanceForm = ({ handleAdvanceSubmit, handleInputChange, errors, formData, propertyType, propertyService, propertySubType,selfType }) => {
  const [floorOptions, setFloorOptions] = useState([]);
  useEffect(() => {
    const totalFloors = parseInt(formData.propertyDetails.total_floor) || 0;
    
    const newOptions = Array.from({ length: totalFloors + 1 }, (_, i) => ({
      label: i.toString(),
      value: i.toString(),
    }));
    setFloorOptions(newOptions);
  },[formData.propertyDetails.total_floor]);

  const ParkingOption = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "3+", label: "3+" }
  ];
  const zeroFourOption = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" }
  ];
  const FacingOptions = [
    { value: "north", label: "North" },
    { value: "east", label: "East" },
    { value: "west", label: "West" },
    { value: "south", label: "South" },
    { value: "north-east", label: "North-East" },
    { value: "north-west", label: "North-West" },
    { value: "south-east", label: "South-East" },
    { value: "south-west", label: "South-West" }
  ];
  const yesNoOption = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];
  const parkingChargeOption = [
    { value: "include_rent", label: "Include in rent" },
    { value: "seprate", label: "Seprate" }
  ];
  const plotAuthority = [
    { value: "RHB", label: "RHB" },
    { value: "JDA", label: "JDA" }
  ];
  const pantingChargeOption = [
    { value: "0", label: "None" },
    { value: "per_cost", label: "As per cost" },
    { value: "1_month", label: "1 month" },
    { value: "custom", label: "Custom" }
  ];

const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  };

  const prevPlotApproved = usePrevious(formData.propertyDetails.plot_approved);
  const prevParkingCharge = usePrevious(formData.propertyDetails.parking_charge);
  const prevPaintingCharge = usePrevious(formData.propertyDetails.painting_charge);
  
  useEffect(() => {
    if (
      prevPlotApproved !== undefined &&
      prevPlotApproved === '1' &&
      formData.propertyDetails.plot_approved !== '1' &&
      formData.propertyDetails.plot_authority
    ) {
      handleInputChange('propertyDetails', 'plot_authority', '');
    }
  
    if (
      prevParkingCharge !== undefined &&
      prevParkingCharge === 'seprate' &&
      formData.propertyDetails.parking_charge !== 'seprate' &&
      formData.propertyDetails.parking_charge_amount
    ) {
      handleInputChange('propertyDetails', 'parking_charge_amount', '');
    }
  
    if (
      prevPaintingCharge !== undefined &&
      prevPaintingCharge === 'custom' &&
      formData.propertyDetails.painting_charge !== 'custom' &&
      formData.propertyDetails.painting_charge_amount
    ) {
      handleInputChange('propertyDetails', 'painting_charge_amount', '');
    }
  }, [
    formData.propertyDetails.plot_approved,
    formData.propertyDetails.parking_charge,
    formData.propertyDetails.painting_charge,
  ]);

  // Input field for role (Builder/Agent) in Residential Sell category
  if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'apartment') {
    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.floor_no || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="floorNo"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_no || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_no', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="floorNo" className="floating-label">
              Floor No.
            </label>
            {errors.floor_no && <small className="text-danger">{errors.floor_no}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
  
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony"  onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );
  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'independent_floor') {
    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.floor_no || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="floorNo"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_no || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_no', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="floorNo" className="floating-label">
              Floor No.
            </label>
            {errors.floor_no && <small className="text-danger">{errors.floor_no}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
    
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing" onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony"  onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label> 
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );
  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'independent_house') {
    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.floor_no || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="floorNo"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_no || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_no.', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="floorNo" className="floating-label">
              Floor No.  
            </label>
            {errors.floor_no && <small className="text-danger">{errors.floor_no}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors  <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address  <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description  <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );
  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'villa') {
    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.floor_no || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="floorNo"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_no || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_no', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="floorNo" className="floating-label">
              Floor No.
            </label>
            {errors.floor_no && <small className="text-danger">{errors.floor_no}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label> 
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing" onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );
  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'plot') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.corner_plot || errors.construction_start ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'corner_plot'} options={yesNoOption} placeholder="Select Corner Plot" required={'1'} onSelect={(value) => console.log("cornor plot:", value)} />
            {errors.corner_plot && <small className="text-danger">{errors.corner_plot}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'construction_start'} options={yesNoOption} placeholder="Select Construction Start" onSelect={(value) => console.log("construction start:", value)} />
            {errors.construction_start && <small className="text-danger">{errors.construction_start}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.boundary_wall ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'boundary_wall'} options={yesNoOption} placeholder="Select Boundary Wall" required={'1'} onSelect={(value) => console.log("boundary wall:", value)} />
            {errors.boundary_wall && <small className="text-danger">{errors.boundary_wall}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.open_sides || errors.floor_construction ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'open_sides'} options={zeroFourOption} placeholder="No. of open sides" onSelect={(value) => console.log("open side:", value)} />
            {errors.open_sides && <small className="text-danger">{errors.open_sides}</small>}
          </div>

          <div className="input-container w-50">
            <input
              type="text"
              id="floor_construction"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_construction || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_construction', e.target.value)}
            />
            <label htmlFor="floor_construction" className="floating-label">
              Floor Allowed for Construction
            </label>
            {errors.floor_construction && <small className="text-danger">{errors.floor_construction}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.width_facing_road || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container w-50">
            <input
              type="text"
              id="width_facing_road"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.width_facing_road || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'width_facing_road', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="width_facing_road" className="floating-label">
              Width of Facing Road <span className='required_field'>*</span>
            </label>
            {errors.width_facing_road && <small className="text-danger">{errors.width_facing_road}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.plot_approved || errors.plot_authority ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'plot_approved'} options={yesNoOption} placeholder="Plot approved by authority" onSelect={(value) => console.log("plot approved:", value)} />
            {errors.plot_approved && <small className="text-danger">{errors.plot_approved}</small>}
          </div>
          {['1'].includes(formData.propertyDetails.plot_approved) && (
                    <>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'plot_authority'} options={plotAuthority} placeholder="Approving Authorities" required={'1'} onSelect={(value) => console.log("approving authorities:", value)} />
            {errors.plot_authority && <small className="text-danger">{errors.plot_authority}</small>}
          </div>
          </>
          )}
          </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'agricultural_land') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.corner_plot || errors.construction_start ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'corner_plot'} required={'1'} options={yesNoOption} placeholder="Select Corner Plot" onSelect={(value) => console.log("cornor plot:", value)} />
            {errors.corner_plot && <small className="text-danger">{errors.corner_plot}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'construction_start'} options={yesNoOption} placeholder="Select Construction Start" onSelect={(value) => console.log("construction start:", value)} />
            {errors.construction_start && <small className="text-danger">{errors.construction_start}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.boundary_wall ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'boundary_wall'} options={yesNoOption} placeholder="Select Boundary Wall" required={'1'} onSelect={(value) => console.log("boundary wall:", value)} />
            {errors.boundary_wall && <small className="text-danger">{errors.boundary_wall}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.open_sides || errors.floor_construction ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'open_sides'} options={zeroFourOption} placeholder="No. of open sides" onSelect={(value) => console.log("open side:", value)} />
            {errors.open_sides && <small className="text-danger">{errors.open_sides}</small>}
          </div>

          <div className="input-container w-50">
            <input
              type="text"
              id="floor_construction"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.floor_construction || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'floor_construction', e.target.value)}
            />
            <label htmlFor="floor_construction" className="floating-label">
              Floor Allowed for Construction
            </label>
            {errors.floor_construction && <small className="text-danger">{errors.floor_construction}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.width_facing_road || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container w-50">
            <input
              type="text"
              id="width_facing_road"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.width_facing_road || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'width_facing_road', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="width_facing_road" className="floating-label">
              Width of Facing Road <span className='required_field'>*</span>
            </label>
            {errors.width_facing_road && <small className="text-danger">{errors.width_facing_road}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.plot_approved || errors.plot_authority ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'plot_approved'} options={yesNoOption} placeholder="Plot approved by authority" onSelect={(value) => console.log("plot approved:", value)} />
            {errors.plot_approved && <small className="text-danger">{errors.plot_approved}</small>}
          </div>
          {['1'].includes(formData.propertyDetails.plot_approved) && (
                    <>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'plot_authority'} options={plotAuthority} placeholder="Approving Authorities" required={'1'} onSelect={(value) => console.log("approving authorities:", value)} />
            {errors.plot_authority && <small className="text-danger">{errors.plot_authority}</small>}
          </div>
          </>
          )}
          </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description 
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Buy/Owner) in Residential Sell category
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'apartment') {
    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years)
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing" onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom" onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );
  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'independent_floor') {

    return (
      <div className="formBody1">
          <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years)
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'independent_house') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years)
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing" onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'villa') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) 
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'plot') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.corner_plot || errors.construction_start ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'corner_plot'} required={'1'} options={yesNoOption} placeholder="Select Corner Plot" onSelect={(value) => console.log("cornor plot:", value)} />
            {errors.corner_plot && <small className="text-danger">{errors.corner_plot}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'construction_start'} options={yesNoOption} placeholder="Select Construction Start" onSelect={(value) => console.log("construction start:", value)} />
            {errors.construction_start && <small className="text-danger">{errors.construction_start}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.boundary_wall ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'boundary_wall'} options={yesNoOption} required={'1'} placeholder="Select Boundary Wall" onSelect={(value) => console.log("boundary wall:", value)} />
            {errors.boundary_wall && <small className="text-danger">{errors.boundary_wall}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.width_facing_road || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container w-50">
            <input
              type="text"
              id="width_facing_road"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.width_facing_road || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'width_facing_road', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="width_facing_road" className="floating-label">
              Width of Facing Road <span className='required_field'>*</span>
            </label>
            {errors.width_facing_road && <small className="text-danger">{errors.width_facing_road}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address <span className='required_field'>*</span>
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description 
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'sell' && propertySubType === 'agricultural_land') {

    return (
      <div className="formBody1">
      <div className={`formRow mt-4 ${errors.corner_plot || errors.construction_start ? "mb-5" : "mb-3"}`}>

<div className='w-50'>
  <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'corner_plot'} required={'1'} options={yesNoOption} placeholder="Select Corner Plot" onSelect={(value) => console.log("cornor plot:", value)} />
  {errors.corner_plot && <small className="text-danger">{errors.corner_plot}</small>}
</div>
<div className='w-50'>
  <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'construction_start'} options={yesNoOption} placeholder="Select Construction Start" onSelect={(value) => console.log("construction start:", value)} />
  {errors.construction_start && <small className="text-danger">{errors.construction_start}</small>}
</div>
      </div>
      <div className={`formRow mt-4 ${errors.facing || errors.boundary_wall ? "mb-5" : "mb-3"}`}>
      <div className='w-50'>
      <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
        {errors.facing && <small className="text-danger">{errors.facing}</small>}
      </div>

      <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'boundary_wall'} options={yesNoOption} placeholder="Select Boundary Wall" required={'1'} onSelect={(value) => console.log("boundary wall:", value)} />
        {errors.boundary_wall && <small className="text-danger">{errors.boundary_wall}</small>}
      </div>

      </div>
      <div className={`formRow mt-4 ${errors.width_facing_road || errors.rera_id ? "mb-5" : "mb-3"}`}>
      <div className="input-container w-50">
        <input
          type="text"
          id="width_facing_road"
          placeholder=" "
          className="textField"
          value={formData.propertyDetails.width_facing_road || ''}
          onChange={(e) => handleInputChange('propertyDetails', 'width_facing_road', e.target.value)}
          onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
        />
        <label htmlFor="width_facing_road" className="floating-label">
          Width of Facing Road <span className='required_field'>*</span>
        </label>
        {errors.width_facing_road && <small className="text-danger">{errors.width_facing_road}</small>}
      </div>

      {/* <div className="input-container w-50">
        <input
          type="text"
          id="rera_id"
          placeholder=" "
          className="textField"
          value={formData.propertyDetails.rera_id || ''}
          onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
        />
        <label htmlFor="reraId" className="floating-label">
          Rera Id
        </label>
        {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
      </div> */}

      </div>
      <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
      <div className="input-container d-grid w-100">
        <input
          type="text"
          id="address"
          placeholder=" "
          className="textField"
          value={formData.propertyDetails.address || ''}
          onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
        />
        <label htmlFor="address" className="floating-label">
          Address <span className='required_field'>*</span>
        </label>
        {errors.address && <small className="text-danger">{errors.address}</small>}
      </div>

      </div>

      <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
      <div className="input-container d-grid w-100">
        <input
          type="text"
          id="propertyDescription"
          placeholder=" "
          className="textField"
          value={formData.propertyDetails.property_description || ''}
          onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
        />
        <label htmlFor="propertyDescription" className="floating-label">
          Property Description 
        </label>
        {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
      </div>

      </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Buy/Owner) in Residential Rent category
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'apartment') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing" onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Panting Charge" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label> 
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom || errors.carpet_area ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
          <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                    </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label> 
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'independent_floor') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking"  onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking"  onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Panting Charge" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom || errors.carpet_area ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
          <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                    </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'independent_house') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking"  onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Panting Charge" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom || errors.carpet_area ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
          <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                    </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 && propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'villa') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Panting Charge" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom || errors.carpet_area ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
          <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                    </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'apartment') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Property Condition" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom || errors.carpet_area ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
          <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                    </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'independent_floor') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking"  onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Property Condition" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'independent_house') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking" onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking" onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Property Condition" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.bathroom ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'residential' && propertyService === 'rent' && propertySubType === 'villa') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.property_age || errors.total_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="propertyAge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_age || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="propertyAge" className="floating-label">
              Age of Property (in years) <span className='required_field'>*</span>
            </label>
            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="totalFloor"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Total Floors <span className='required_field'>*</span>
            </label>
            {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_open'} options={ParkingOption} placeholder="Select Open Parking"  onSelect={(value) => console.log("open parking:", value)} />
            {errors.parking_open && <small className="text-danger">{errors.parking_open}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_covered'} options={ParkingOption} placeholder="Select Closed Parking"  onSelect={(value) => console.log("closed parking:", value)} />
            {errors.parking_covered && <small className="text-danger">{errors.parking_covered}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.parking_charge || errors.parking_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'parking_charge'} options={parkingChargeOption} placeholder="Select Parking Charge" onSelect={(value) => console.log("parking charge:", value)} />
            {errors.parking_charge && <small className="text-danger">{errors.parking_charge}</small>}
          </div>
          {['seprate'].includes(formData.propertyDetails.parking_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="parking_charge_amount"
              placeholder=""
              className="textField"
              value={formData.propertyDetails.parking_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'parking_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="parking_charge_amount" className="floating-label">
            Parking Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.parking_charge_amount && <small className="text-danger">{errors.parking_charge_amount}</small>}
          </div>
          )}
        </div>
        <div className={`formRow mt-4 ${errors.facing || errors.servent_room ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'facing'} options={FacingOptions} placeholder="Select Facing"  onSelect={(value) => console.log("facing:", value)} />
            {errors.facing && <small className="text-danger">{errors.facing}</small>}
          </div>

          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'servent_room'} options={yesNoOption} placeholder="Select Servant Room" onSelect={(value) => console.log("servent room:", value)} />
            {errors.servent_room && <small className="text-danger">{errors.servent_room}</small>}
          </div>

        </div>
        <div className={`formRow mt-4 ${errors.painting_charge || errors.painting_charge_amount ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'painting_charge'} options={pantingChargeOption} placeholder="Select Property Condition" onSelect={(value) => console.log("property condition:", value)} />
            {errors.painting_charge	 && <small className="text-danger">{errors.painting_charge	}</small>}
          </div>
          {['custom'].includes(formData.propertyDetails.painting_charge) && (
          <div className="input-container w-50">
            <input
              type="text"
              id="painting_charge_amount"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.painting_charge_amount || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'painting_charge_amount', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="painting_charge_amount" className="floating-label">
            Painting Charge Amount <span className='required_field'>*</span>
            </label>
            {errors.painting_charge_amount && <small className="text-danger">{errors.painting_charge_amount}</small>}
          </div>
          )}

        </div>
        
        <div className={`formRow mt-4 ${errors.balcony || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'balcony'} options={zeroFourOption} placeholder="Select Balcony" required={'1'} onSelect={(value) => console.log("balcony:", value)} />
            {errors.balcony && <small className="text-danger">{errors.balcony}</small>}
          </div>

          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.bathroom ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'bathroom'} options={zeroFourOption} placeholder="Select Bathroom"  onSelect={(value) => console.log("bathroom:", value)} />
            {errors.bathroom && <small className="text-danger">{errors.bathroom}</small>}
          </div>
        </div>

        <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="address"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.address || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
            />
            <label htmlFor="address" className="floating-label">
              Address 
            </label>
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field in Residential Living category
  else if (propertyType === 'residential' && propertyService === 'living') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.meal_charge || errors.electricity_charge ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="meal_charge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.meal_charge || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'meal_charge', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="meal_charge" className="floating-label">
              Meals Charges(per Month)
            </label>
            {errors.meal_charge && <small className="text-danger">{errors.meal_charge}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="electricity_charge"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.electricity_charge || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'electricity_charge', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="totalFloor" className="floating-label">
              Electricity Charges(per Month)
            </label>
            {errors.electricity_charge && <small className="text-danger">{errors.electricity_charge}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.non_veg || errors.opposite_sex ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'non_veg'} options={yesNoOption} placeholder="Non Veg Allowed" required={'1'} onSelect={(value) => console.log("non veg allowed:", value)} />
            {errors.non_veg && <small className="text-danger">{errors.non_veg}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'opposite_sex'} options={yesNoOption} placeholder="Opposite Sex Allowed" required={'1'} onSelect={(value) => console.log("opposite sex allowed:", value)} />
            {errors.opposite_sex && <small className="text-danger">{errors.opposite_sex}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.drinking_allowed || errors.smoking_allowed ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'drinking_allowed'} options={yesNoOption} placeholder="Drinking Allowed" required={'1'} onSelect={(value) => console.log("drinking allowed:", value)} />
            {errors.drinking_allowed && <small className="text-danger">{errors.drinking_allowed}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'smoking_allowed'} options={yesNoOption} placeholder="Smoking Allowed" required={'1'} onSelect={(value) => console.log("smoking allowed:", value)} />
            {errors.smoking_allowed && <small className="text-danger">{errors.smoking_allowed}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.visitor_allowed || errors.guardian_allowed ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'visitor_allowed'} options={yesNoOption} placeholder="Visitors Allowed" required={'1'} onSelect={(value) => console.log("visitor allowed:", value)} />
            {errors.visitor_allowed && <small className="text-danger">{errors.visitor_allowed}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'guardian_allowed'} options={yesNoOption} placeholder="Guardian Allowed" required={'1'} onSelect={(value) => console.log("guardian allowed:", value)} />
            {errors.guardian_allowed && <small className="text-danger">{errors.guardian_allowed}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Builder/Agent) in Commercial Rent category
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'office') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.service_lift || errors.passenger_lifts ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="service_lift"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.service_lift || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'service_lift', e.target.value)}
            />
            <label htmlFor="service_lift" className="floating-label">
              Service Lift
            </label>
            {errors.service_lift && <small className="text-danger">{errors.service_lift}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="passenger_lifts"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.passenger_lifts || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'passenger_lifts', e.target.value)}
            />
            <label htmlFor="passenger_lifts" className="floating-label">
              Public Lift 
            </label>
            {errors.passenger_lifts && <small className="text-danger">{errors.passenger_lifts}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms 
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms 
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.dg_ups_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.water_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'water_charges'} options={yesNoOption} placeholder="Water Charges" onSelect={(value) => console.log("water charges:", value)} />
            {errors.water_charges && <small className="text-danger">{errors.water_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_stairs || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-50">
            <input
              type="text"
              id="total_stairs"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_stairs || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_stairs', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="reraId" className="floating-label">
              Number of Staircase
            </label>
            {errors.total_stairs && <small className="text-danger">{errors.total_stairs}</small>}
          </div>
          {/* <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'retailshop') {

    return (
      <div className="formBody1">
       <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}   multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms 
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'showroom') {

    return (
      <div className="formBody1">
       <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms 
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms 
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'warehouse') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'plot') {

    return (
      <div className="formBody1">

        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
          {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
        </div>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
          {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
        </div>
        </div>
        <div className={`formRow mt-4 ${errors.rera_id || errors.lock_period  ? "mb-5" : "mb-3"}`}>
          {/* <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}
          <div className="input-container w-50">
                            <input
                              type="text"
                              id="lock_period"
                              placeholder=" "
                              value={formData.propertyDetails.lock_period || ''}
                              onChange={(e) => handleInputChange('propertyDetails', 'lock_period', e.target.value)}
                              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                              className="textField"
                            />
                            <label htmlFor="lock_period" className="floating-label">
                              Lock in Period
                            </label>
                            {errors.lock_period && <small className="text-danger">{errors.lock_period}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-100">
          <input
            type="text"
            id="propertyDescription"
            placeholder=" "
            className="textField"
            value={formData.propertyDetails.property_description || ''}
            onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
          />
          <label htmlFor="propertyDescription" className="floating-label">
            Property Description <span className='required_field'>*</span>
          </label>
          {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
        </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'other') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
          {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
        </div>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
          {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
        </div>
        </div>
        <div className={`formRow mt-4 ${errors.water_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'water_charges'} options={yesNoOption} placeholder="Water Charges" onSelect={(value) => console.log("water charge:", value)} />
            {errors.water_charges && <small className="text-danger">{errors.water_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.lock_period ? "mb-5" : "mb-3"}`}>
        <div className="input-container w-50">
                            <input
                              type="text"
                              id="lock_period"
                              placeholder=" "
                              value={formData.propertyDetails.lock_period || ''}
                              onChange={(e) => handleInputChange('propertyDetails', 'lock_period', e.target.value)}
                              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                              className="textField"
                            />
                            <label htmlFor="lock_period" className="floating-label">
                              Lock in Period
                            </label>
                            {errors.lock_period && <small className="text-danger">{errors.lock_period}</small>}
          </div>

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Buy/Owner) in Commercial Rent category
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'office') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.service_lift || errors.passenger_lifts ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="service_lift"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.service_lift || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'service_lift', e.target.value)}
            />
            <label htmlFor="service_lift" className="floating-label">
              Service Lift 
            </label>
            {errors.service_lift && <small className="text-danger">{errors.service_lift}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="passenger_lifts"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.passenger_lifts || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'passenger_lifts', e.target.value)}
            />
            <label htmlFor="passenger_lifts" className="floating-label">
              Public Lift 
            </label>
            {errors.passenger_lifts && <small className="text-danger">{errors.passenger_lifts}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms 
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.dg_ups_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.water_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'water_charges'} options={yesNoOption} placeholder="Water Charges" onSelect={(value) => console.log("water charges:", value)} />
            {errors.water_charges && <small className="text-danger">{errors.water_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_stairs || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="total_stairs"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_stairs || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_stairs', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="reraId" className="floating-label">
              Number of Staircase
            </label>
            {errors.total_stairs && <small className="text-danger">{errors.total_stairs}</small>}
          </div>
          {/* <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'retailshop') {

    return (
      <div className="formBody1">
       <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'showroom') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.electricity_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'warehouse') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
      
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'plot') {

    return (
      <div className="formBody1">

        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
          {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
        </div>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
          {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
        </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-50">
          <input
            type="text"
            id="rera_id"
            placeholder=" "
            className="textField"
            value={formData.propertyDetails.rera_id || ''}
            onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
          />
          <label htmlFor="reraId" className="floating-label">
            Rera Id
          </label>
          {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
        </div>

        </div> */}
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-100">
          <input
            type="text"
            id="propertyDescription"
            placeholder=" "
            className="textField"
            value={formData.propertyDetails.property_description || ''}
            onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
          />
          <label htmlFor="propertyDescription" className="floating-label">
            Property Description <span className='required_field'>*</span>
          </label>
          {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
        </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'rent' && propertySubType === 'other') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
          {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
        </div>
        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
          {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
        </div>
        </div>
        <div className={`formRow mt-4 ${errors.water_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'water_charges'} options={yesNoOption} placeholder="Water Charges" onSelect={(value) => console.log("water charge:", value)} />
            {errors.water_charges && <small className="text-danger">{errors.water_charges}</small>}
          </div>
          {/* <div className="input-container w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Builder/Agent) in Commercial Sell category
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'office') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.service_lift || errors.passenger_lifts ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="service_lift"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.service_lift || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'service_lift', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="service_lift" className="floating-label">
              Service Lift
            </label>
            {errors.service_lift && <small className="text-danger">{errors.service_lift}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="passenger_lifts"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.passenger_lifts || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'passenger_lifts', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="passenger_lifts" className="floating-label">
              Public Lift
            </label>
            {errors.passenger_lifts && <small className="text-danger">{errors.passenger_lifts}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.dg_ups_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_stairs || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-50">
            <input
              type="text"
              id="total_stairs"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_stairs || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_stairs', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="reraId" className="floating-label">
              Number of Staircase
            </label>
            {errors.total_stairs && <small className="text-danger">{errors.total_stairs}</small>}
          </div>
          {/* <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'retailshop') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

        <div className='w-50'>
        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
          {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
        </div>
        <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
          {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
        </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'showroom') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

<div className='w-50'>
<CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
  {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
</div>
<div className='w-50'>
  <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
  {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
</div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'warehouse') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'plot') {

    return (
      <div className="formBody1">
                <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

              <div className='w-50'>
              <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
                {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
              </div>
              <div className='w-50'>
                <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
                {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
              </div>
            </div>
            {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
            <div className="input-container d-grid w-50">
              <input
                type="text"
                id="rera_id"
                placeholder=" "
                className="textField"
                value={formData.propertyDetails.rera_id || ''}
                onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
              />
              <label htmlFor="reraId" className="floating-label">
                Rera Id
              </label>
              {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
            </div>

            </div> */}
            <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
            <div className="input-container d-grid w-100">
              <input
                type="text"
                id="propertyDescription"
                placeholder=" "
                className="textField"
                value={formData.propertyDetails.property_description || ''}
                onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
              />
              <label htmlFor="propertyDescription" className="floating-label">
                Property Description <span className='required_field'>*</span>
              </label>
              {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
            </div>

            </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 6 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'other') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" isMulti={true} onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

            <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
              {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
            </div>
            <div className='w-50'>
              <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
              {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
            </div>
        </div>
        <div className={`formRow mt-4 ${errors.dg_ups_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        {/* <div className="input-container d-grid w-50">
          <input
            type="text"
            id="rera_id"
            placeholder=" "
            className="textField"
            value={formData.propertyDetails.rera_id || ''}
            onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
          />
          <label htmlFor="reraId" className="floating-label">
            Rera Id
          </label>
          {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
        </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  // Input field for role (Buy/Owner) in Commercial Sell category
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'office') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.service_lift || errors.passenger_lifts ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="service_lift"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.service_lift || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'service_lift', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="service_lift" className="floating-label">
              Service Lift
            </label>
            {errors.service_lift && <small className="text-danger">{errors.service_lift}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="passenger_lifts"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.passenger_lifts || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'passenger_lifts', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="passenger_lifts" className="floating-label">
              Public Lift
            </label>
            {errors.passenger_lifts && <small className="text-danger">{errors.passenger_lifts}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.dg_ups_charges ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.total_stairs || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className="input-container d-grid w-50">
            <input
              type="text"
              id="total_stairs"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.total_stairs || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_stairs', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="reraId" className="floating-label">
              Number of Staircase
            </label>
            {errors.total_stairs && <small className="text-danger">{errors.total_stairs}</small>}
          </div>
          {/* <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
            {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
          </div>
        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'retailshop') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

<div className='w-50'>
<CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
  {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
</div>
<div className='w-50'>
  <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
  {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
</div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'showroom') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.entrance_width || errors.ceiling_height ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="entrance_width"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.entrance_width || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'entrance_width', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="entrance_width" className="floating-label">
              Entrance width in feet <span className='required_field'>*</span>
            </label>
            {errors.entrance_width && <small className="text-danger">{errors.entrance_width}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="ceiling_height"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.ceiling_height || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'ceiling_height', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="ceiling_height" className="floating-label">
              Ceiling height in feet <span className='required_field'>*</span>
            </label>
            {errors.ceiling_height && <small className="text-danger">{errors.ceiling_height}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

<div className='w-50'>
<CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" onSelect={(value) => console.log("negotiable:", value)} />
  {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
</div>
<div className='w-50'>
  <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
  {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
</div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'warehouse') {

    return (
      <div className="formBody1">
        <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
      
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
            {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
          </div>
          <div className='w-50'>
          <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
            {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
          </div>
        </div>
        {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="text"
              id="rera_id"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.rera_id || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
            />
            <label htmlFor="reraId" className="floating-label">
              Rera Id
            </label>
            {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
          </div>

        </div> */}
        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'plot') {

    return (
      <div className="formBody1">
                <div className={`formRow mt-4 ${errors.negotiable || errors.electricity_charges ? "mb-5" : "mb-3"}`}>

<div className='w-50'>
<CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
  {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
</div>
<div className='w-50'>
<CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'electricity_charges'} options={yesNoOption} placeholder="Electricity Charges" onSelect={(value) => console.log("electricity charge:", value)} />
  {errors.electricity_charges && <small className="text-danger">{errors.electricity_charges}</small>}
</div>
            </div>
            {/* <div className={`formRow mt-4 ${errors.rera_id ? "mb-5" : "mb-3"}`}>
            <div className="input-container d-grid w-50">
              <input
                type="text"
                id="rera_id"
                placeholder=" "
                className="textField"
                value={formData.propertyDetails.rera_id || ''}
                onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
              />
              <label htmlFor="reraId" className="floating-label">
                Rera Id
              </label>
              {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
            </div>

            </div> */}
            <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
            <div className="input-container d-grid w-100">
              <input
                type="text"
                id="propertyDescription"
                placeholder=" "
                className="textField"
                value={formData.propertyDetails.property_description || ''}
                onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
              />
              <label htmlFor="propertyDescription" className="floating-label">
                Property Description <span className='required_field'>*</span>
              </label>
              {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
            </div>

            </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
  else if (selfType === 5 &&  propertyType === 'commercial' && propertyService === 'sell' && propertySubType === 'other') {

    return (
      <div className="formBody1">
         <div className={`formRow mt-4 ${errors.total_floor || errors.your_floor ? "mb-5" : "mb-3"}`}>
          <div className="input-container w-50">
            <input
              type="text"
              id="total_floor"
              placeholder=" "
              value={formData.propertyDetails.total_floor || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              className="textField"
            />
            <label htmlFor="total_floor" className="floating-label">
              Total Floor
            </label>
          </div>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'your_floor'}  multiple={true} options={floorOptions} placeholder="Select Your Floor" isMulti={true} onSelect={(value) => console.log("your floor:", value)} />
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_parking || errors.public_parking ? "mb-5" : "mb-3"}`}>
          <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'private_parking'} options={ParkingOption} placeholder="Select Private Parking" onSelect={(value) => console.log("private parking:", value)} />
            {errors.private_parking && <small className="text-danger">{errors.private_parking}</small>}
          </div>
          <div className=' w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'public_parking'} options={ParkingOption} placeholder="Select Public Parking" onSelect={(value) => console.log("public parking:", value)} />
            {errors.public_parking && <small className="text-danger">{errors.public_parking}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.private_washroom || errors.public_washroom ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="private_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.private_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'private_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="private_washroom" className="floating-label">
              Private Washrooms
            </label>
            {errors.private_washroom && <small className="text-danger">{errors.private_washroom}</small>}
          </div>
          <div className="input-container d-grid w-50">
            <input
              type="number"
              id="public_washroom"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.public_washroom || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'public_washroom', e.target.value)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
            />
            <label htmlFor="public_washroom" className="floating-label">
            Public Washrooms
            </label>
            {errors.public_washroom && <small className="text-danger">{errors.public_washroom}</small>}
          </div>
        </div>
        <div className={`formRow mt-4 ${errors.negotiable || errors.tax_govt_charges ? "mb-5" : "mb-3"}`}>

            <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'negotiable'} options={yesNoOption} placeholder="Negotiable" required={'1'} onSelect={(value) => console.log("negotiable:", value)} />
              {errors.negotiable && <small className="text-danger">{errors.negotiable}</small>}
            </div>
            <div className='w-50'>
              <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'tax_govt_charges'} options={yesNoOption} placeholder="Tax & Govt. Charge" onSelect={(value) => console.log("tax_govt:", value)} />
              {errors.tax_govt_charges && <small className="text-danger">{errors.tax_govt_charges}</small>}
            </div>
        </div>
        <div className={`formRow mt-4 ${errors.dg_ups_charges || errors.rera_id ? "mb-5" : "mb-3"}`}>
        <div className='w-50'>
            <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'dg_ups_charges'} options={yesNoOption} placeholder="DG & UPS Charge included" onSelect={(value) => console.log("dg_ups:", value)} />
            {errors.dg_ups_charges && <small className="text-danger">{errors.dg_ups_charges}</small>}
          </div>
        {/* <div className="input-container d-grid w-50">
          <input
            type="text"
            id="rera_id"
            placeholder=" "
            className="textField"
            value={formData.propertyDetails.rera_id || ''}
            onChange={(e) => handleInputChange('propertyDetails', 'rera_id', e.target.value)}
          />
          <label htmlFor="reraId" className="floating-label">
            Rera Id
          </label>
          {errors.rera_id && <small className="text-danger">{errors.rera_id}</small>}
        </div> */}

        </div>

        <div className={`formRow mt-4 ${errors.property_description ? "mb-5" : "mb-3"}`}>
          <div className="input-container d-grid w-100">
            <input
              type="text"
              id="propertyDescription"
              placeholder=" "
              className="textField"
              value={formData.propertyDetails.property_description || ''}
              onChange={(e) => handleInputChange('propertyDetails', 'property_description', e.target.value)}
            />
            <label htmlFor="propertyDescription" className="floating-label">
              Property Description <span className='required_field'>*</span>
            </label>
            {errors.property_description && <small className="text-danger">{errors.property_description}</small>}
          </div>

        </div>
        <div className="ribbon">
          <button className="ribbonText" onClick={(e) => handleAdvanceSubmit(e)}>Save</button>
        </div>
      </div>
    );

  }
};

export default AdvanceForm;
